import type { PmNodeConverter, PmNodeJson } from './../pm-converters/types';
import type { CollapsibleListData, Node } from './../ricos-schema/legacy/wix/rich_content/v1';
import { CollapsibleListData_InitialExpandedItems, Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type {
  CollapsibleItemBodyNode,
  CollapsibleItemNode,
  CollapsibleItemTitleNode,
  CollapsibleListNode,
} from './../ricos-schema/next-schema';

export const collapsibleListConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.COLLAPSIBLE_LIST],
    // @ts-ignore $TSFixMe
    convert: (node: CollapsibleListNode, visit: (node: CollapsibleItemNode) => PmNodeJson[]) => ({
      type: Node_Type.COLLAPSIBLE_LIST,
      attrs: {
        ...node.collapsibleListData,
        id: node.id,
      },
      content: node.nodes.map((collapsibleItem, index) => {
        const expandState = node.collapsibleListData?.initialExpandedItems;
        return {
          type: Node_Type.COLLAPSIBLE_ITEM,
          attrs: {
            id: collapsibleItem.id,
            isExpanded:
              expandState === CollapsibleListData_InitialExpandedItems.ALL ||
              (index === 0 && expandState === CollapsibleListData_InitialExpandedItems.FIRST),
            expandOnlyOne: !!node.collapsibleListData?.expandOnlyOne,
          },
          content: visit(collapsibleItem),
        };
      }),
    }),
  },
  fromPm: {
    types: [Node_Type.COLLAPSIBLE_LIST],
    // @ts-ignore $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { attrs = {} } = node;
      const { id, ...collapsibleListData } = attrs;

      return {
        type: Node_Type.COLLAPSIBLE_LIST,
        id,
        nodes: visit(node),
        collapsibleListData: {
          ...(collapsibleListData as CollapsibleListData),
          expandOnlyOne: collapsibleListData.expandOnlyOne || undefined,
        },
      };
    },
  },
};

export const collapsibleItemConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM],
    // @ts-ignore $TSFixMe
    convert: (node: CollapsibleItemNode, visit: (node: CollapsibleItemNode) => PmNodeJson[]) => ({
      type: Node_Type.COLLAPSIBLE_ITEM,
      attrs: {
        id: node.id,
      },
      content: visit(node),
    }),
  },
  fromPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM],
    // @ts-ignore $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM,
        id,
        nodes: visit(node),
      };
    },
  },
};

export const collapsibleItemTitleConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM_TITLE],
    // @ts-ignore $TSFixMe
    convert: (
      node: CollapsibleItemTitleNode,
      visit: (node: CollapsibleItemTitleNode) => PmNodeJson[]
    ) => ({
      type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
      attrs: {
        id: node.id,
      },
      content: visit(node),
    }),
  },
  fromPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM_TITLE],
    // @ts-ignore $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
        id,
        nodes: visit(node),
      };
    },
  },
};

export const collapsibleItemBodyConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM_BODY],
    // @ts-ignore $TSFixMe
    convert: (
      node: CollapsibleItemBodyNode,
      visit: (node: CollapsibleItemBodyNode) => PmNodeJson[]
    ) => ({
      type: Node_Type.COLLAPSIBLE_ITEM_BODY,
      attrs: {
        id: node.id,
      },
      content: visit(node),
    }),
  },
  fromPm: {
    types: [Node_Type.COLLAPSIBLE_ITEM_BODY],
    // @ts-ignore $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.COLLAPSIBLE_ITEM_BODY,
        id,
        nodes: visit(node),
      };
    },
  },
};
